import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance3047yo46wk0eo as Companion_getInstance } from '../../../../../ktor-ktor-http/io/ktor/http/HttpStatusCode.mjs';
import {
  Send_instance3smuuitxedznj as Send_instance,
  Sender1wtdgti85uk42 as Sender,
} from './api/CommonHooks.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_authority2s3hk87lssumy as get_authority } from '../../../../../ktor-ktor-http/io/ktor/http/Url.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { takeFrom3rd40szpqy350 as takeFrom } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { isSecurex1qiiavqi0xu as isSecure } from '../../../../../ktor-ktor-http/io/ktor/http/URLProtocol.mjs';
import { get_authorityakhc3pgcrb9j as get_authority_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Companion_getInstance12092dx8psw4e as Companion_getInstance_0 } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { EventDefinition1fymk8xrdelhn as EventDefinition } from '../../../../../ktor-ktor-events/io/ktor/events/Events.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ALLOWED_FOR_REDIRECT() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return ALLOWED_FOR_REDIRECT;
}
var ALLOWED_FOR_REDIRECT;
function get_LOGGER() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return LOGGER;
}
var LOGGER;
function get_HttpResponseRedirectEvent() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpResponseRedirectEvent;
}
var HttpResponseRedirectEvent;
function get_HttpRedirect() {
  _init_properties_HttpRedirect_kt__ure7fo();
  return HttpRedirect;
}
var HttpRedirect;
var HttpRedirectConfigClass;
function HttpRedirectConfig() {
  if (HttpRedirectConfigClass === VOID) {
    class $ {
      constructor() {
        this.e5q_1 = true;
        this.f5q_1 = false;
      }
    }
    initMetadataForClass($, 'HttpRedirectConfig', HttpRedirectConfig);
    HttpRedirectConfigClass = $;
  }
  return HttpRedirectConfigClass;
}
function isRedirect(_this__u8e3s4) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var tmp0_subject = _this__u8e3s4.y52_1;
  return tmp0_subject === Companion_getInstance().h51_1.y52_1 || tmp0_subject === Companion_getInstance().i51_1.y52_1 || (tmp0_subject === Companion_getInstance().n51_1.y52_1 || (tmp0_subject === Companion_getInstance().o51_1.y52_1 || tmp0_subject === Companion_getInstance().j51_1.y52_1)) ? true : false;
}
function HttpRedirectConfig$_init_$ref_rhym9t() {
  var l = () => new (HttpRedirectConfig())();
  l.callableName = '<init>';
  return l;
}
function HttpRedirect$lambda($this$createClientPlugin) {
  _init_properties_HttpRedirect_kt__ure7fo();
  var checkHttpMethod = $this$createClientPlugin.o5m_1.e5q_1;
  var allowHttpsDowngrade = $this$createClientPlugin.o5m_1.f5q_1;
  var tmp = Send_instance;
  $this$createClientPlugin.r5m(tmp, HttpRedirect$lambda$slambda_0(checkHttpMethod, allowHttpsDowngrade, $this$createClientPlugin));
  return Unit_instance;
}
function *_generator_invoke$handleCall__nrwzaa(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
  var call = origin;
  var requestBuilder = context;
  while (true) {
    var previousProtocol = call.z5h().i5i().d54_1;
    var previousAuthority = get_authority(call.z5h().i5i());
    if (!isRedirect(call.d5g().p5i()))
      return call;
    var location = call.d5g().a50().l2o('Location');
    if (location == null) {
      get_LOGGER().d4s('Location header missing from redirect response ' + call.z5h().i5i().toString() + '; returning response as is');
      return call;
    }
    client.v5f_1.h4s(get_HttpResponseRedirectEvent(), call.d5g());
    get_LOGGER().f4s('Received redirect response to ' + location + ' for request ' + call.z5h().i5i().toString());
    // Inline function 'kotlin.apply' call
    var this_0 = new (HttpRequestBuilder())();
    this_0.t5k(requestBuilder);
    this_0.g5g_1.n53_1.f5();
    takeFrom(this_0.g5g_1, location);
    if (!allowHttpsDowngrade && isSecure(previousProtocol) && !isSecure(this_0.g5g_1.q53())) {
      get_LOGGER().f4s('Blocked redirect from ' + call.z5h().i5i().toString() + ' to ' + location + ' due to HTTPS downgrade');
      return call;
    }
    if (!(previousAuthority === get_authority_0(this_0.g5g_1))) {
      this_0.i5g_1.l4o('Authorization');
      get_LOGGER().f4s('Removing Authorization header for cross-authority redirect: ' + (previousAuthority + ' -> ' + this_0.g5g_1.a55()));
    }
    requestBuilder = this_0;
    var tmp = _this__u8e3s4.f5p(requestBuilder, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    call = tmp;
  }
}
function invoke$handleCall(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke$handleCall__nrwzaa.bind(VOID, _this__u8e3s4, context, origin, allowHttpsDowngrade, client), $completion);
}
function *_generator_invoke__zhh2q8($this, $this$on, request, $completion) {
  var tmp = $this$on.f5p(request, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var origin = tmp;
  if ($this.g5q_1 && !get_ALLOWED_FOR_REDIRECT().y2(origin.z5h().h5i())) {
    return origin;
  }
  var tmp_0 = invoke$handleCall($this$on, request, origin, $this.h5q_1, $this.i5q_1.n5m_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
var HttpRedirect$lambda$slambdaClass;
function HttpRedirect$lambda$slambda() {
  if (HttpRedirect$lambda$slambdaClass === VOID) {
    class $ {
      constructor($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin) {
        this.g5q_1 = $checkHttpMethod;
        this.h5q_1 = $allowHttpsDowngrade;
        this.i5q_1 = $this_createClientPlugin;
      }
      h5p($this$on, request, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$on, request), $completion);
      }
      vd(p1, p2, $completion) {
        var tmp = p1 instanceof Sender() ? p1 : THROW_CCE();
        return this.h5p(tmp, p2 instanceof HttpRequestBuilder() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpRedirect$lambda$slambdaClass = $;
  }
  return HttpRedirect$lambda$slambdaClass;
}
function HttpRedirect$lambda$slambda_0($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin) {
  var i = new (HttpRedirect$lambda$slambda())($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin);
  var l = ($this$on, request, $completion) => i.h5p($this$on, request, $completion);
  l.$arity = 2;
  return l;
}
var properties_initialized_HttpRedirect_kt_klj746;
function _init_properties_HttpRedirect_kt__ure7fo() {
  if (!properties_initialized_HttpRedirect_kt_klj746) {
    properties_initialized_HttpRedirect_kt_klj746 = true;
    ALLOWED_FOR_REDIRECT = setOf([Companion_getInstance_0().b50_1, Companion_getInstance_0().g50_1]);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
    HttpResponseRedirectEvent = new (EventDefinition())();
    var tmp = HttpRedirectConfig$_init_$ref_rhym9t();
    HttpRedirect = createClientPlugin('HttpRedirect', tmp, HttpRedirect$lambda);
  }
}
//region block: exports
export {
  get_HttpRedirect as get_HttpRedirect1lgx3wewnhrb0,
};
//endregion

//# sourceMappingURL=HttpRedirect.mjs.map
